export default [
  {
    path: '/public/document/:token',
    name: 'public-document-viewer',
    component: () => import('@/views/public/DocumentViewer.vue'),
    meta: {
      layout: 'full',
      allowAnonymous: true,
      auth: false,
    },
  },
]
